import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    addQuestion,
    modalToggle,
    setEditQuestion,
} from "../../slices/predictionSlice";
// import PredictionQuestion from "../../components/PredictionQuestion";
import axios from "axios";
import { getChildQuestions, getQuestions } from "../../slices/apiCalling";
import { Link, useParams } from "react-router-dom";
import { PREDICTION_CHILD } from "../../constant/endpoint";
import { Breadcrumbs, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { MdNavigateNext } from "react-icons/md";


function PredictionChildView(props) {
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={'/matchlist'} >
            <h4>Matchlist</h4>
        </Link>, <Link
            underline="hover"
            color="inherit"
        >
            Prediction
        </Link>, <h5>{' Info'}</h5>
    ];
    
    let { match_id,series_id,prediction_id } = useParams();
    const [data,setData] = useState([])
    useEffect(()=>{
        getChildPrediciton()
    },[])
    const getChildPrediciton = async () => {
        const response = await axios.get(PREDICTION_CHILD.replace(':prediction_id',prediction_id))
        if(response?.data?.status === 'success'){
            setData(response?.data?.data)
        }
    }

    return (
        <div>
              <div className="homeCard">
                <div className='subHomeCard'>
              <Breadcrumbs
                        separator={<MdNavigateNext fontSize="small" />}
                        aria-label="breadcrumb"
                    >

                        {breadcrumbs}
                </Breadcrumbs>
                        <Table responsive hover>
                <TableHead>
                    <TableRow>
                        <TableCell scope="col">S No</TableCell>
                        <TableCell scope='col'>Prediction Id</TableCell>
                        <TableCell scope="col">Question</TableCell>
                        <TableCell scope="col">Slots</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data?.map((data, i) => {
                        return (
                            <TableRow key={i}>
                                <TableCell>{i + 1}</TableCell>
                                <TableCell>{data._id}</TableCell>
                                <TableCell>{data.question_english}</TableCell>
                                <TableCell>{data.slots}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
                </div>
            </div>
        </div>
    );
}


export default PredictionChildView;